import { isValidPhoneNumber } from 'react-phone-number-input';
import z from 'zod';

import { INVALID_CONTACT_MESSAGE } from '@/components/Inputs/contactMessages';
import type { SegmentedOption } from '@/components/SegmentedControl';
import type { InviteEmailTemplate } from '@/store/auth/auth.dto';
import { GUEST_COUNT_ERRORS } from '@/store/invites/invites.mappers';

/** The looks the invitation email can take, for the Email Style picker. */
export const EMAIL_TEMPLATES: SegmentedOption<InviteEmailTemplate>[] = [
  { value: 'classic', label: 'Classic Card' },
  { value: 'envelope', label: 'Envelope' },
  { value: 'come_aboard', label: 'Come Aboard' },
];

export const guestInvitationSchema = z.object({
  contact: z
    .string()
    .email(INVALID_CONTACT_MESSAGE)
    .or(
      z
        .string()
        .min(1, INVALID_CONTACT_MESSAGE)
        .refine((value) => isValidPhoneNumber(value), {
          message: INVALID_CONTACT_MESSAGE,
        }),
    ),
  name: z.string().min(1, 'Please enter a name.'),
});

export type InviteCrewMember = z.infer<typeof guestInvitationSchema>;

/** An invitation to an event, which may bring the guest's own guests along. */
export const eventGuestInvitationSchema = guestInvitationSchema.extend({
  additionalGuests: z
    .number({ error: GUEST_COUNT_ERRORS.empty })
    .int(GUEST_COUNT_ERRORS.notWhole)
    .min(0, GUEST_COUNT_ERRORS.negative),
});

export type EventGuestInvitation = z.infer<typeof eventGuestInvitationSchema>;
